
import { mapGetters } from 'vuex'
import PlanNoteForm from '~/components/PlanNoteForm.vue'
import { describeAppliesTo, describeStates } from '~/util/plan-notes'

// A plan card's notes on the quotes page: the notes that card shows, and the
// shared PlanNoteForm with this plan fixed. Saves through the store so the
// page's planNotes stay in step.
export default {
    components: { PlanNoteForm },
    props: {
        plan: { type: Object, required: true },
        value: { type: Boolean, default: false },
    },
    data () {
        return {
            show: this.value,
            saving: false,
            editing: null,
            formKey: 0,
        }
    },
    computed: {
        ...mapGetters(['year']),
        notes () {
            return this.$store.getters.planNotesForPlan(this.plan)
        },
        // A new note starts pinned to this plan; switching to Rule starts
        // from this plan's catalog carrier (notes match on it, not on the
        // display rewrite), type and subtype.
        newDefaults () {
            return {
                scope: 'plan',
                carrier: this.plan.original_carrier || this.plan.carrier || '',
                plan_type: this.plan.plan_type || null,
                plan_subtype: this.plan.plan_subtype ? [this.plan.plan_subtype] : [],
            }
        },
    },
    watch: {
        value (v) { this.show = v },
        show (v) { this.$emit('input', v) },
    },
    methods: {
        describeAppliesTo,
        describeStates,
        startEdit (note) {
            this.editing = note
            this.formKey += 1
        },
        cancelEdit () {
            if (!this.editing) {
                this.show = false
                return
            }
            this.editing = null
            this.formKey += 1
        },
        async saveNote (payload) {
            this.saving = true
            try {
                if (this.editing) {
                    await this.$store.dispatch('savePlanNote', { id: this.editing.id, ...payload })
                } else {
                    await this.$store.dispatch('createPlanNote', payload)
                }
                this.editing = null
                this.formKey += 1
            } finally {
                this.saving = false
            }
        },
        async removeNote (note) {
            if (confirm('Delete this note?')) {
                await this.$store.dispatch('deletePlanNote', note.id)
            }
        },
    },
}
